import { IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class DealDetailsDto {
    @IsString()
    assetCode!: string;
    @IsString()
    contractDescript!: string;
    @IsString()
    paymentNotes!: string;
    @Type(() => ContractRate)
    @ValidateNested()
    contractRates!: ContractRate[];
    @Type(() => ReduceRate)
    @ValidateNested()
    reduceRates!: ReduceRate[];
    @Type(() => DealNote)
    @ValidateNested()
    notes!: DealNote[];
    @Type(() => KeyDate)
    @ValidateNested()
    keyDates!: KeyDate[];

    @Type(() => PaymentDate)
    @ValidateNested()
    paymentDates!: PaymentDate[];
    @Type(() => AdvancesDate)
    @ValidateNested()
    advancesDates!: AdvancesDate[];
    @Type(() => Recoupables)
    @ValidateNested()
    recoupables!: Recoupables[];
    @Type(() => RoyaltyRates)
    @ValidateNested()
    royaltyRates!: RoyaltyRates[];
    @Type(() => contractSubTypeList)
    @ValidateNested()
    contractSubTypeList!: contractSubTypeList[];
    signatureDate!: any;
    contractContact!: any;
    contractLegalContact!: any;
}

export class ContractRate {
    @IsString()
    contractRefNum!: string;
    @IsOptional()
    @IsString()
    contractTitle!: string | null;
    @IsString()
    groupingID!: string;
    @IsNumber()
    defaultTerritory!: number;
    @IsString()
    contractRegion!: string;
    @IsNumber()
    incomeRate!: number;
    @IsNumber()
    totalRows!: number;
}

export class ReduceRate {
    @IsString()
    contractRefNum!: string;
    @IsString()
    groupingID!: string;
    @IsNumber()
    defaultTerritory!: number;
    @IsString()
    contractRegion!: string;
    @IsNumber()
    incomeRate!: number;
    @IsString()
    codeDesc!: string;
    @IsString()
    recoupDesc!: string;
    @IsNumber()
    totalRows!: number;
}

export class DealNote {
    @IsString()
    contractRefNum!: string;
    @IsString()
    contractNotes!: string;
    @IsString()
    contractClause!: string;
    @IsNumber()
    totalRows!: number;
}

export class KeyDate {
    @IsString()
    contractRefNum!: string;
    @IsString()
    retContractNotes!: string;
    @IsString()
    retContractClause!: string;
    @IsString()
    retActionDate!: string;
    @IsString()
    retStartDate!: string;
    @IsNumber()
    totalRows!: number;
}

export class PaymentDate {
    @IsString()
    contractRefNum!: string;
    @IsString()
    payContractNotes!: string;
    @IsString()
    payContractClause!: string;
    @IsString()
    payActionDate!: string;
    @IsString()
    payStartDate!: string;
    @IsString()
    payFrequency!: string;
    @IsString()
    payDate1!: string;
    @IsString()
    payDate2!: string;
    @IsNumber()
    totalRows!: number;
}

export class AdvancesDate {
    @IsString()
    contractRefNum!: string;
    @IsString()
    advContractNotes!: string;
    @IsString()
    advContractClause!: string;
    @IsString()
    advActionDate!: string;
    @IsString()
    advStartDate!: string;
    @IsNumber()
    advAmount!: number;
    @IsNumber()
    totalRows!: number;
}

export class Recoupables {
    @IsOptional()
    contractRecoupCode!: any;
    @IsOptional()
    contractRecoupID!: any;
    @IsOptional()
    contractRecoupRate!: any;
    @IsOptional()
    contractRecoupRegion!: any;
    @IsOptional()
    contractRefNum!: any;
}

export class RoyaltyRates {
    @IsOptional()
    contractRateFormat!: any;
    @IsOptional()
    contractRateID!: any;
    @IsOptional()
    contractRateRate!: any;
    @IsOptional()
    contractRateRegion!: any;
    @IsOptional()
    contractRefNum!: any;
}

export class contractSubTypeList {
    @IsNumber()
    accStatusExtUseId!: number;
    @IsNumber()
    accStatusUseId!: number;
    @IsString()
    contractRefNum!: string;
    @IsNumber()
    contractSubTypeID!: number;
    @IsString()
    freeText!: string;
}
